import React, { ReactNode } from 'react';
import { List } from '@mui/material';
import SidebarItem, { SidebarItemProps } from './sidebar-item';

interface SidebarProps {
    pages: SidebarItemProps[];
    closeDrawer: () => void;
    children: ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ pages, closeDrawer, children }) => {
    return (
        <List>
            {children}
            {pages.map((page) => (
                <SidebarItem {...page} key={page.title} closeDrawer={closeDrawer} />
            ))}
        </List>
    );
};

export default Sidebar;
